// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import { CFAuthGetRef } from 'auth';
import { locations } from '../../common/redux/action_locations';
import {
  FETCH_OPPORTUNITY_ANSWERS,
  RECEIVED_OPPORTUNITY_ANSWERS,
} from './constants';

export function fetchOpportunityAnswersAction(filters) {
  return {
    type: FETCH_OPPORTUNITY_ANSWERS,
    fetchCall: fetchOpportunityAnswers,
    receivedAction: receivedOpportunityAnswers,
    data: {
      locations,
      filters,
    },
  };
}

export function fetchOpportunityAnswers(filters) {
  return CFAuthGetRef({
    url: `${process.env.REACT_APP_COACHING_API_URL}/api/CoachingOpportunities/${filters.opportunityId}/Answers`,
    params: null,
    originURL: process.env.PUBLIC_URL,
    loaderName: 'fetchOpportunityAnswers'
  });
}

export function receivedOpportunityAnswers(data) {
  return {
    type: RECEIVED_OPPORTUNITY_ANSWERS,
    data,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case RECEIVED_OPPORTUNITY_ANSWERS:
      return {
        ...state,
        opportunityAnswers: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/agent-coaching/redux/fetchOpportunityAnswers.js